const KEY_FIRST = 'cc_first_touch';
const KEY_LAST = 'cc_last_touch';

function classify() {
  const params = new URLSearchParams(window.location.search);
  const utm = (params.get('utm_source') || params.get('ref') || '').toLowerCase().slice(0, 50);
  const path = window.location.pathname;
  const shareSlug = path.startsWith('/r/') ? path.split('/')[2] : null;
  if (utm) return { source: utm, shareSlug, landing: path };
  if (shareSlug) return { source: 'shared_report', shareSlug, landing: path };
  const ref = document.referrer;
  if (!ref) return { source: 'direct', shareSlug, landing: path };
  let host = '';
  try { host = new URL(ref).hostname; } catch { /* invalid referrer */ }
  if (!host || host === window.location.hostname) return { source: null };
  let source = 'referral';
  if (/google\./.test(host)) source = 'google';
  else if (/linkedin\.|lnkd\.in/.test(host)) source = 'linkedin';
  else if (/facebook\.|fb\.com|fb\.me|messenger/.test(host)) source = 'facebook';
  else if (/instagram\./.test(host)) source = 'instagram';
  else if (/tiktok\./.test(host)) source = 'tiktok';
  else if (/whatsapp\.|wa\.me/.test(host)) source = 'whatsapp';
  else if (/twitter\.|t\.co$|x\.com/.test(host)) source = 'twitter';
  else if (/bing\.|duckduckgo\.|qwant\.|ecosia\./.test(host)) source = 'search_other';
  return { source, shareSlug, landing: path };
}

export function captureAcquisition() {
  try {
    const { source, shareSlug, landing } = classify();
    if (!source) return;
    const touch = JSON.stringify({ source, landing, share_slug: shareSlug || null, at: new Date().toISOString() });
    if (!localStorage.getItem(KEY_FIRST)) localStorage.setItem(KEY_FIRST, touch);
    localStorage.setItem(KEY_LAST, touch);
  } catch { /* storage unavailable */ }
}

export function getAcquisition() {
  try {
    const f = JSON.parse(localStorage.getItem(KEY_FIRST) || 'null');
    const l = JSON.parse(localStorage.getItem(KEY_LAST) || 'null');
    if (!f && !l) return null;
    return {
      first_touch_source: f?.source || null,
      first_touch_landing: f?.landing || null,
      first_touch_share_slug: f?.share_slug || null,
      last_touch_source: l?.source || null,
    };
  } catch {
    return null;
  }
}
